export default "__VITE_ASSET__NMdI3$fI__"